import { ImageOrientation } from '@space-core/components/customImage/enum'
import clsx from 'clsx'
import styled from 'styled-components'

import type { CardProps } from './types'

import DefaultBaseCard from '../base/default'
import { CardOrientation } from '../base/enum'

const Wrapper = styled.div`
  bottom: 0;
  opacity: 0;
`

const Title = styled.h3`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-break: auto;

  &:hover {
    color: var(--custom-color-dark) !important;
  }
`

const Description = styled.p<{ orientation: ImageOrientation }>`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  ${({ orientation }) => `
    -webkit-line-clamp: ${orientation === ImageOrientation.HORIZONTAL ? '2' : '4'};
  `}
  -webkit-box-orient: vertical;
  line-break: auto;
`

const ProductCardDefault = ({
  product,
  items,
  orientation,
  containerOrientation,
  imageOrientation,
  stylesCustomProductCommunity
}: CardProps) => {
  const contentContainerClass = clsx(
    '_d-flex _flex-column _justify-content-center _align-items-start _h-full',
    {
      '_p-0 _pt-4': orientation === CardOrientation.VERTICAL
    }
  )

  return (
    <DefaultBaseCard
      coverImage={product.coverImage}
      avatar={product.avatar}
      avatarAltText={product.avatarAltText}
      thumbnailImage={product.thumbnailImage}
      imageAlt={product.altText}
      verticalCoverPage={product.verticalCoverPage}
      verticalAltText={product.verticalAltText}
      freeSignup={product.freeSignup}
      orientation={orientation}
      containerOrientation={containerOrientation}
      imageOrientation={imageOrientation}
      items={items}
      stylesCustomProductCommunity={stylesCustomProductCommunity}>
      {imageOrientation === ImageOrientation.HORIZONTAL && (
        <div className={contentContainerClass}>
          <p className='_font-14 _text-gray-900 _text-left _mb-2'>{product.category}</p>

          <Title className='_font-18 _text-gray-900 _text-left _mb-2 _pt-0 _pb-0'>
            {product.name}
          </Title>

          <Description
            orientation={imageOrientation}
            className='_font-14 _text-left _text-gray-600 _mb-2 _w-full'>
            {product.description}
          </Description>

          {Boolean(product.price) && !product.isPurchased && (
            <p className='_m-0 _text-2 _font-weight-bold _text-green'>{product.price}</p>
          )}
        </div>
      )}
      {imageOrientation === ImageOrientation.VERTICAL && (
        <Wrapper className='_w-full _child-vertical _position-absolute _p-5'>
          <Description
            orientation={imageOrientation}
            className='_font-14 _text-left _text-white _mb-1 _w-full'>
            {product.description}
          </Description>
        </Wrapper>
      )}
    </DefaultBaseCard>
  )
}

export default ProductCardDefault
